import { module } from 'modujs';
import { gsap } from 'gsap';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {

		this.needOnMobile = true;

		if(typeof this.getData('desktop') == 'string') {
			this.needOnMobile = false;
		}
		
		if(window.isMobile) {
			if(this.needOnMobile) {
				this.load();
			}
		} else {
			this.load();
		}

    }

	load() {
		gsap.delayedCall(0.3,() => {
			this.el.src = this.el.getAttribute('data-src');
			this.el.play();
			
			this.bindLoaded = this.loaded.bind(this);
			this.el.addEventListener('canplaythrough', this.bindLoaded);
		});
	}

	loaded() {
		this.el.classList.add('is-loaded');
	}

	destroy() {

	}
}
